export default __webpack_public_path__ + "static/media/petar_l.bf90b360.jpg";